import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiResourceSchema } from '../common/schemas';
import { fetchJson } from '../fetch';
import { QueryKeys } from '../keys';
import { draftQuotationSchema } from './schemas';
import { quotationQueryOptions } from './useQuotation';

export const useDuplicateQuotation = (id: number) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      const { data: quotation } = await fetchJson(`/quotations/${id}/duplicate`, {
        method: 'POST',
        schema: apiResourceSchema(draftQuotationSchema),
      });

      return quotation;
    },
    onSuccess: (quotation) => {
      queryClient.setQueryData(quotationQueryOptions(quotation.id).queryKey, quotation);
      queryClient.invalidateQueries({ queryKey: QueryKeys.quotations.index.root });
    },
  });
};
